import React from 'react';

import appConfig from '@/config/appConfig.typed';
import analyticsEventValues from '@/consts/analytics/analyticsEventValues';
import {
    AUTO_DELIVERY_INACTIVE_BUTTON,
    AUTO_DELIVERY_INACTIVE_BUTTON_ARIA_LABEL,
} from '@/consts/localization/localizationKeys';
import {PUSH_NOTIFICATIONS_PROMPT_TYPES} from '@/consts/pushNotifications/pushNotificationsPromptTypes';
import amplitudeAutodeliveryTracking from '@/services/analytics/amplitude/amplitudeAutoDeliveryTracking';
import googleAnalyticsService from '@/services/analytics/ga/googleAnalyticsService';
import {schedulePushPromptIfNeeded} from '@/services/pushNotification/pushNotificationPromptService';

import AutoDeliveryButton from '../AutoDeliveryButton';

const AutoDeliveryInactiveButton = (props) => {
    const amplitudeEvent = () => {
        schedulePushPromptIfNeeded(PUSH_NOTIFICATIONS_PROMPT_TYPES.AUTODELIVERY_DASHBOARD_CLICK);
        amplitudeAutodeliveryTracking.trackAutoDeliveryDashboardButtonClick(analyticsEventValues.REACTIVATE);
        googleAnalyticsService.trackAutoDeliveryDashboardButtonClick(analyticsEventValues.REACTIVATE);
    };

    return (
        <AutoDeliveryButton
            localizationKey={AUTO_DELIVERY_INACTIVE_BUTTON}
            ariaLabelKey={AUTO_DELIVERY_INACTIVE_BUTTON_ARIA_LABEL}
            amplitudeEvent={amplitudeEvent}
            externalLinkConfig={appConfig.getAutoDeliveryInactiveExternalLink()}
            {...props}
        />
    );
};

export default AutoDeliveryInactiveButton;
